/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCellMiddle = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M8 22H2v-6h6zm-4-2h2v-2H4zm11 2H9v-6h6zm-4-2h2v-2h-2zm11 2h-6v-6h6zm-4-2h2v-2h-2zM8 15H2V9h6zm-4-2h2v-2H4zm11 2H9V9h6zm7 0h-6V9h6zm-4-2h2v-2h-2zM8 8H2V2h6zM4 6h2V4H4zm11 2H9V2h6zm-4-2h2V4h-2zm11 2h-6V2h6zm-4-2h2V4h-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCellMiddle as CellMiddle };
